import React from 'react';
import { FiDownload, FiX } from 'react-icons/fi';

function InstallPrompt() {
  const [installEvent, setInstallEvent] = React.useState(null);
  const [isInstalled, setIsInstalled] = React.useState(false);
  const [dismissed, setDismissed] = React.useState(false);
  const [showIosHelp, setShowIosHelp] = React.useState(false);

  React.useEffect(() => {
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    const isStandalone = mediaQuery.matches || window.navigator.standalone === true;
    if (isStandalone) {
      setIsInstalled(true);
    }

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallEvent(event);
    };

    const handleInstalled = () => {
      setIsInstalled(true);
      setInstallEvent(null);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleInstalled);
    };
  }, []);

  const userAgent = navigator.userAgent || '';
  const isIos = /iphone|ipad|ipod/i.test(userAgent);
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);

  if (isInstalled || dismissed) {
    return null;
  }

  const handleInstall = async () => {
    if (installEvent) {
      installEvent.prompt();
      const choice = await installEvent.userChoice;
      if (choice.outcome !== 'accepted') {
        setDismissed(true);
      }
      setInstallEvent(null);
      return;
    }

    if (isIos && isSafari) {
      setShowIosHelp((value) => !value);
    }
  };

  if (!installEvent && !(isIos && isSafari)) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-4 z-[120] flex justify-center px-4">
      <div className="w-full max-w-md rounded-[1.5rem] border border-emerald-400/25 bg-slate-950/95 p-4 text-white shadow-[0_18px_60px_rgba(0,0,0,0.45)] backdrop-blur-xl">
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-emerald-300/75">
              Install App
            </p>
            <h3 className="mt-1 text-lg font-semibold">Put DailyProfit on your home screen</h3>
            <p className="mt-2 text-sm text-slate-300">
              Open the trader like an app, with a full-screen layout and faster re-entry.
            </p>
          </div>
          <button
            type="button"
            onClick={() => setDismissed(true)}
            className="rounded-full bg-white/5 p-2 text-slate-300 hover:bg-white/10"
            aria-label="Dismiss install prompt"
          >
            <FiX className="h-4 w-4" />
          </button>
        </div>

        <div className="mt-4 flex items-center gap-3">
          <button
            type="button"
            onClick={handleInstall}
            className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-emerald-300 to-cyan-300 px-4 py-2 text-sm font-semibold text-slate-950 transition hover:scale-[1.01]"
          >
            <FiDownload className="h-4 w-4" />
            Install now
          </button>
          {isIos && isSafari && (
            <span className="text-xs text-slate-400">Safari: use Share then Add to Home Screen.</span>
          )}
        </div>

        {showIosHelp && (
          <div className="mt-3 rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-slate-300">
            On iPhone, tap the Share button in Safari, then choose Add to Home Screen.
          </div>
        )}
      </div>
    </div>
  );
}

export default InstallPrompt;